export const convertToArrayOfObjWithValue = (arr, valuePropertyName = 'name') =>
  arr.map((item) => ({ id: item.id, value: item[valuePropertyName], ...item }));
